import React, { useState } from "react";

function CarsList({ data, patching }) {
  const [likes, setLikes] = useState({});

  function handleClick(id) {
    console.log('clicked car with id ' + id);
    const newPrice = prompt("Enter New Price");
    const newQuantity = prompt("Enter New Quantity");
    const newData = {
      quantity: parseInt(newQuantity),
      price: parseInt(newPrice)  // Assuming price is an integer
    };
    patching(id, newData);
    console.log("New Price is " + newPrice);
    // fetching()
  }

  function handleLike(id) {
    setLikes(prevLikes => ({
      ...prevLikes,
      [id]: prevLikes[id] ? prevLikes[id] + 1 : 1
    }));
  }

  const dataList = Array.isArray(data) && data.map((datum) => {
    return (
      <div id="cars-list" key={datum.id}>
        <div className="card">
          <button className="btn" onClick={() => handleClick(datum.id)}>Edit</button>
          <button className={`like-btn ${likes[datum.id] ? 'liked' : ''}`} onClick={() => handleLike(datum.id)}>
           <i className="fa fa-heart"></i> ♡
           </button>
          <span className="like-count">{likes[datum.id] || 0}</span>

          <h1 className="brand">Brand:{datum.brand}  ({datum.year} Model)</h1>
          <img className="image" src={datum.image} alt="car" />
          <p className="mileage">Mileage: {datum.mileage}</p>
          <p className="mileage">Price: Ksh{datum.price}</p>
          <p className="quantity">Stock:{datum.quantity} cars</p>
          
        </div>
      </div>
    )
  });

  return (
    <div id="container">
      {dataList}
    </div>
  );
}

export default CarsList;
